import {getAction, postAction} from '@/api/manage'

const api = {
    pageList: '/online/mallDecorateV2/page/list',
    pageDetail: '/online/mallDecorateV2/page/detail',
    pageInit: '/online/mallDecorateV2/page/init',
    saveDraft: '/online/mallDecorateV2/page/saveDraft',
    publishAll: '/online/mallDecorateV2/page/publishAll',
    applyAll: '/online/mallDecorateV2/template/applyAll',
    templateList: '/online/mallDecorateV2/template/list',
    templatePreview: '/online/mallDecorateV2/template/preview',
    themeList: '/online/mallDecorateV2/theme/list',
    enableV2: '/online/mallDecorateV2/store/enableV2'
}

export function initMallDecorateV2(storeShopId) {
    return postAction(`${api.pageInit}?storeShopId=${storeShopId}`, {})
}

export function listMallPageV2(storeShopId) {
    return getAction(api.pageList, {storeShopId})
}

export function getMallPageV2(storeShopId, pageType) {
    return getAction(api.pageDetail, {storeShopId, pageType})
}

export function saveMallPageV2Draft(data) {
    return postAction(api.saveDraft, data)
}

export function publishMallPageV2(storeShopId) {
    return postAction(`${api.publishAll}?storeShopId=${storeShopId}`, {})
}

export function applyMallTemplateV2(data) {
    return postAction(api.applyAll, data)
}

export function listMallTemplateV2() {
    return getAction(api.templateList)
}

export function previewMallTemplateV2(params) {
    return getAction(api.templatePreview, params)
}

export function listMallThemeV2() {
    return getAction(api.themeList)
}

export function enableMallDecorateV2(data) {
    return postAction(api.enableV2, data)
}
